
import {defineComponent} from 'vue';
import LoginPage from "@/components/LoginPage.vue";
import HomePage from "@/components/HomePage.vue";
import Footer from "@/components/Footer.vue";
import {tokenLifetime} from "@/config/app-settings";


export default defineComponent({
  name: 'App',
  components: {
    HomePage,
    LoginPage,
    Footer
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.loggedIn;
    },
    tokenStillValid() {
      return Date.now() - tokenLifetime < this.$store.state.tokenTimestamp;
    }
  },
  methods: {
    logoutIfTokenExpired() {
      if (!this.tokenStillValid) {
        this.$store.dispatch('logout')
      }
    }
  },
  watch: {
    tokenStillValid() {
      this.logoutIfTokenExpired()
    }
  },
  mounted() {
    this.logoutIfTokenExpired()
  }
});
